<div *ngIf="!childConfig.config.isHidden">
    <div class="tml-tpl-ctrl-wrap">
        <div class="tam-contact-control">
            <kendo-dropdownlist [style.width.px]="childConfig.css.leftWidth"
                [(ngModel)]="childConfig.config.defaultValue" [disabled]="true">
            </kendo-dropdownlist>
        </div>

        <div class="tam-contact-control">
            <kendo-dropdownlist [style.width.px]="childConfig.css.rightWidth" [disabled]="true"
                placeholder="country/region" [(ngModel)]="childConfig.config.defaultValueCountry">
            </kendo-dropdownlist>
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth" [disabled]="true" />
        </div>
        <div class="tam-contact-control">
            <input class="tam-input" [style.width.px]="childConfig.css.rightWidth" [disabled]="true"
                placeholder="street1" />
        </div>
        <div class="address-required-icon">
            <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth" [disabled]="true" />
        </div>

        <div class="tam-contact-control">
            <input class="tam-input" [style.width.px]="childConfig.css.rightWidth" [disabled]="true"
                placeholder="street2" />
        </div>
    </div>
    <div class="tml-tpl-ctrl-wrap">
        <div class="tam-contact-control" [style.visibility]="'hidden'">
            <input class="tam-input" [style.width.px]="childConfig.css.leftWidth" [disabled]="true" />
        </div>
        <div class="tam-contact-control">
            <input class="tam-input" [style.width.px]="cityWidth" [disabled]="true" placeholder="city" />
        </div>
        <div class="address-required-icon">
            <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
        </div>
        <div class="tam-contact-control">
            <kendo-combobox [style.width.px]="cityWidth" [disabled]="true" placeholder="state/province">
            </kendo-combobox>
        </div>
        <div class="address-required-icon">
            <span *ngIf="childConfig.config.isRequired" style="color:red;">*</span>
        </div>
        <div class="tam-contact-control">
            <input class="tam-input" [style.width.px]="cityWidth" [disabled]="true" placeholder="zip" />
        </div>
    </div>

</div>